<template>
    <span :style="styleObj"></span>
</template>

<script>
export default {
    data() {
        return {
            framesPerSecond: 30,
            durationMs: 1000,

            dataUrl: null,
            pixels: null,
            running: true,
            currentFrame: 0,
            lastFrame: -1,
            styleObj: {
                display: "inline-block",
                width: null,
                height: null,
                "background-image": null,
                "background-size": "cover",
                "background-repeat": "no-repeat",
                "background-position-y": "0px",
                "background-position-x": null,
            },
            requestAnimationId: null,
        };
    },
    computed: {
        frames() {
            return Math.round(this.framesPerSecond * (this.durationMs / 1000));
        },
    },
    watch: {
        frames: {
            handler() {
                this.$nextTick(function () {
                    this.reload();
                });
            },
        },
    },
    methods: {
        cssUrl() {
            if (typeof this.dataUrl !== "string" || this.dataUrl == "")
                return null;
            return "url(" + this.dataUrl + ")";
        },
        renderSprite() {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            const style = getComputedStyle(this.$el);
            ctx.font = style.font;

            const pixels = Math.max(
                4,
                Math.round(
                    parseFloat(
                        style.fontSize.substr(0, style.fontSize.length - 2)
                    )
                )
            );

            canvas.width = pixels * this.frames;
            canvas.height = pixels;

            ctx.lineWidth = Math.max(1, Math.round(pixels * 0.1));

            const radianStep = (2 * Math.PI) / this.frames;
            let r = 0;
            for (let i = 0; i < this.frames; i++) {
                const left = pixels * i;
                const centerX = left + pixels / 2;
                const centerY = pixels / 2;
                ctx.beginPath();
                ctx.arc(
                    centerX,
                    centerY,
                    pixels / 2 - ctx.lineWidth * 2,
                    r,
                    r + 0.5 * Math.PI
                );
                ctx.stroke();
                r += radianStep;
            }

            this.dataUrl = canvas.toDataURL("image/png");
            this.pixels = pixels;
            this.styleObj.width = this.pixels + "px";
            this.styleObj.height = this.pixels + "px";
            this.styleObj["background-image"] = this.cssUrl();
        },
        animationFrameCallback(ms) {
            //console.log("FRAME", this, arguments);
            const newFrameNumber = Math.floor(ms / this.framesPerSecond);
            if (newFrameNumber > this.lastFrame) {
                const currentFrame = this.currentFrame % this.frames;

                const offset = 0 - currentFrame * this.pixels;

                this.styleObj["background-position-x"] = offset + "px";

                this.currentFrame = currentFrame + 1;

                this.lastFrame = newFrameNumber;
            }
            if (this.running === true) {
                this.requestAnimationId = requestAnimationFrame(
                    this.animationFrameCallback
                );
            }
        },
        start() {
            this.renderSprite();
            this.running = true;
            this.requestAnimationId = requestAnimationFrame(
                this.animationFrameCallback
            );
        },
        stop() {
            this.running = false;
            cancelAnimationFrame(this.requestAnimationId);
        },
        reload() {
            this.stop();
            this.start();
        },
    },
    mounted() {
        this.start();
    },
    beforeUnmount() {
        this.stop();
    },
};
</script>
